import { Star } from "lucide-react";

export const StarRating = ({ value, onChange, size = 28, readOnly = false }) => (
  <div className="flex gap-1" data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={readOnly}
        data-testid={`star-${n}`}
        onClick={() => onChange && onChange(n)}
        className={readOnly ? "cursor-default" : "cursor-pointer hover:scale-110 transition-transform"}
      >
        <Star
          size={size}
          className={n <= value ? "fill-[#FF4F00] text-[#FF4F00]" : "text-zinc-300"}
        />
      </button>
    ))}
  </div>
);
